export class TreatmentProcModel {
    treatmentID: number
    Seq: number
    PetNo: number
    Generate: boolean
    dtpDate: string
    txtNoPerDay: string
    txtDays: number
    txtTotal: number
    immediately: boolean
    next: boolean
    TreatmentProc: boolean
    txtFrequency: string 
    txtRemainTimes: string 

    constructor(
        TreatmentId: number,
        Seq: number,
        PetNo: number,
        Generate: boolean,
        dtpDate: string,
        txtNoPerDay: string,
        txtDays: number,
        txtTotal: number,
        immediately: boolean,
        next: boolean,
        TreatmentProc: boolean,
        txtFrequency: string ,
        txtRemainTimes: string 
    ) {
        this.treatmentID = TreatmentId
        this.Seq = Seq
        this.PetNo = PetNo
        this.Generate = Generate
        this.dtpDate = dtpDate
        this.txtNoPerDay = txtNoPerDay
        this.txtDays = txtDays
        this.txtTotal = txtTotal
        this.immediately = immediately
        this.next = next
        this.TreatmentProc = TreatmentProc
        this.txtFrequency = txtFrequency 
        this.txtRemainTimes =  txtRemainTimes
    }
}